module.exports = __webpack_public_path__ + "img/tg4_title.c014072c.png";